import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CVBuilder from 'Containers/CVBuilder/CVBuilder';

function RouteHandler() {
    return (
        <main className="container">
            <Router>
                <Routes>
                    <Route path="/" element={<CVBuilder />} />
                </Routes>
            </Router>
        </main>
    );
}

export default RouteHandler;
